<template>
  <b-modal
    modal-class="component-modal-lab-company"
    id="LabCompanyModal"
    ref="LabCompanyModal"
    title="บริษัทแลป"
    size="lg"
    no-close-on-backdrop
    hide-footer
    @hidden="handleModalHidden"
  >
    <!-- List View -->
    <div v-if="viewMode === 'list'">
      <div class="mb-3">
        <b-button variant="primary" size="sm" @click="openAddForm">
          <i class="fas fa-plus"></i> เพิ่มบริษัท
        </b-button>
      </div>
      <b-table
        id="dxCateTable"
        ref="dxCateTable"
        hover
        small
        sort-icon-left
        head-variant="light"
        :items="getLabCompanyList"
        :fields="fields"
      >
        <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
        <template v-slot:cell(erpVendorNo)="row">{{
          row.item.erpVendorNo
        }}</template>
        <template v-slot:cell(nameTh)="row">{{ row.item.nameTh }}</template>
        <template v-slot:cell(nameEn)="row">{{ row.item.nameEn }}</template>
        <template v-slot:cell(buttons)="row">
          <b-button-group size="sm">
            <b-button
              variant="outline-info"
              @click="openEditForm(row.item)"
            >
              <i class="fas fa-pencil-alt"></i>
            </b-button>
            <b-button
              variant="outline-danger"
              @click="deleteLabCompanyItem(row.item)"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </div>

    <!-- Form View -->
    <div v-else>
      <h5 class="mb-3">
        {{ isEditMode ? "แก้ไขบริษัทแลป" : "เพิ่มบริษัทแลป" }}
      </h5>
      <b-form @submit.stop.prevent="saveCompany">
        <b-form-group
          v-if="isEditMode"
          label="รหัสลูกค้า:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            v-model="companyForm.erpVendorNo"
            disabled
            maxlength="20"
            size="sm"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="ชื่อลูกค้า:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            class="required"
            v-model="companyForm.nameTh"
            :class="{ 'is-invalid': $v.companyForm.nameTh.$error }"
            maxlength="100"
            size="sm"
            placeholder="กรอกชื่อลูกค้า"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="ชื่อลูกค้า(Eng):"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            v-model="companyForm.nameEn"
            maxlength="100"
            size="sm"
            placeholder="กรอกชื่อลูกค้า(Eng)"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="ประเภทกลุ่มลูกค้า:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            class="required"
            v-model="companyForm.vendorTemplate"
            :class="{ 'is-invalid': $v.companyForm.vendorTemplate.$error }"
            maxlength="20"
            size="sm"
            placeholder="กรอกประเภทกลุ่มลูกค้า"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="เลขประจำตัวผู้เสียภาษี:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            class="required"
            v-model="companyForm.vatRegistrationNo"
            :class="{
              'is-invalid': $v.companyForm.vatRegistrationNo.$error,
            }"
            maxlength="20"
            size="sm"
            placeholder="กรอกเลขประจำตัวผู้เสียภาษี"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="ชื่อผู้ติดต่อ:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            v-model="companyForm.contact"
            maxlength="100"
            size="sm"
            placeholder="กรอกชื่อผู้ติดต่อ"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="เบอร์โทรศัพท์:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            v-model="companyForm.phoneNo"
            maxlength="30"
            size="sm"
            placeholder="กรอกเบอร์โทรศัพท์"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="ที่อยู่ 1:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            class="required"
            v-model="companyForm.address"
            :class="{ 'is-invalid': $v.companyForm.address.$error }"
            maxlength="100"
            size="sm"
            placeholder="กรอกที่อยู่"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="ที่อยู่ 2:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            v-model="companyForm.address2"
            maxlength="50"
            size="sm"
            placeholder="กรอกที่อยู่เพิ่มเติม (ถ้ามี)"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="อำเภอ / เขต:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            v-model="companyForm.city"
            maxlength="30"
            size="sm"
            placeholder="กรอกอำเภอ / เขต"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="จังหวัด:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            v-model="companyForm.county"
            maxlength="30"
            size="sm"
            placeholder="กรอกจังหวัด"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="รหัสไปรษณีย์:"
          label-cols-md="4"
          label-align="right"
        >
          <b-form-input
            v-model="companyForm.postCode"
            maxlength="20"
            size="sm"
            placeholder="กรอกรหัสไปรษณีย์"
          ></b-form-input>
        </b-form-group>

        <div class="d-flex justify-content-between mt-3">
          <b-button variant="secondary" size="sm" @click="backToList">
            <i class="fas fa-arrow-left"></i> ย้อนกลับ
          </b-button>
          <b-button type="submit" variant="primary" size="sm">
            {{ isEditMode ? "แก้ไขรายการ" : "สร้างรายการ" }}
          </b-button>
        </div>
      </b-form>
    </div>

    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import { required, maxLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import "@/theme/modal/DxCateItem.scss";

export default {
  name: "LabCompanyModal",
  components: {
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      viewMode: "list",
      isEditMode: false,
      companyForm: {
        id: null,
        erpVendorNo: "",
        nameTh: "",
        nameEn: "",
        vendorTemplate: "",
        vatRegistrationNo: "",
        contact: "",
        phoneNo: "",
        address: "",
        address2: "",
        city: "",
        county: "",
        postCode: "",
      },
      fields: [
        {
          key: "index",
          label: "",
          class: "text-center",
        },
        {
          key: "erpVendorNo",
          label: "รหัสลูกค้า",
          sortable: true,
        },
        {
          key: "nameTh",
          label: "ชื่อบริษัท",
          sortable: true,
        },
        {
          key: "nameEn",
          label: "ชื่อบริษัท(Eng)",
          sortable: true,
        },
        {
          key: "buttons",
          label: "",
          class: "text-center show-when-hovered",
        },
      ],
    };
  },
  validations: {
    companyForm: {
      nameTh: { required, maxLength: maxLength(100) },
      vendorTemplate: { required, maxLength: maxLength(20) },
      vatRegistrationNo: { required, maxLength: maxLength(20) },
      address: { required, maxLength: maxLength(100) },
    },
  },
  computed: {
    ...mapGetters({
      getLabCompanyList: "moduleLab/getLabCompanyList",
    }),
  },
  methods: {
    ...mapActions({
      fetchLabCompanyList: "moduleLab/fetchLabCompanyList",
      createLabCompany: "moduleLab/createLabCompany",
      editLabCompany: "moduleLab/editLabCompany",
      deleteLabCompanyitem: "moduleLab/deleteLabCompanyitem",
    }),
    show() {
      this.$bvModal.show("LabCompanyModal");
    },
    openAddForm() {
      this.resetForm();
      this.isEditMode = false;
      this.viewMode = "form";
    },
    openEditForm(item) {
      this.companyForm = {
        id: item.id,
        erpVendorNo: item.erpVendorNo || "",
        nameTh: item.nameTh || "",
        nameEn: item.nameEn || "",
        vendorTemplate: item.vendorTemplate || "",
        vatRegistrationNo: item.vatRegistrationNo || "",
        contact: item.contact || "",
        phoneNo: item.phoneNo || "",
        address: item.address || "",
        address2: item.address2 || "",
        city: item.city || "",
        county: item.county || "",
        postCode: item.postCode || "",
      };
      this.isEditMode = true;
      this.viewMode = "form";
    },
    saveCompany() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.isLoading = true;
      const event = { ...this.companyForm };
      delete event.erpVendorNo;
      delete event.id;
      const payload = {
        event,
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
      };

      const action = this.isEditMode
        ? this.editLabCompany(payload)
        : this.createLabCompany(payload);

      action
        .then(() => {
          this.showDialogToast(
            "success",
            this.isEditMode
              ? `แก้ไขบริษัท "${this.companyForm.nameTh}" สำเร็จ`
              : `สร้างบริษัท "${this.companyForm.nameTh}" สำเร็จ`
          );
          this.refreshList();
          this.backToList();
        })
        .catch((err) => {
          const errorMsg =
            err.response?.data?.errorMessage ||
            (this.isEditMode
              ? `แก้ไขบริษัท "${this.companyForm.nameTh}" ไม่สำเร็จ`
              : `สร้างบริษัท "${this.companyForm.nameTh}" ไม่สำเร็จ`);
          this.showDialogToast("warning", errorMsg);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    backToList() {
      this.resetForm();
      this.viewMode = "list";
    },
    resetForm() {
      this.companyForm = {
        id: null,
        erpVendorNo: "",
        nameTh: "",
        nameEn: "",
        vendorTemplate: "",
        vatRegistrationNo: "",
        contact: "",
        phoneNo: "",
        address: "",
        address2: "",
        city: "",
        county: "",
        postCode: "",
      };
      this.isEditMode = false;
      if (this.$v) {
        this.$v.$reset();
      }
    },
    deleteLabCompanyItem(eventData) {
      this.isLoading = true;
      this.deleteLabCompanyitem({
        event: eventData,
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
      })
        .then(() => {
          this.refreshList();
          this.showDialogToast(
            "success",
            `ลบบริษัท "${eventData.nameTh}" สำเร็จ`
          );
        })
        .catch((err) => {
          const errorMessage = err.response?.data?.errorMessage;
          const errorMsg = typeof errorMessage === "string"
            ? errorMessage
            : `ลบบริษัท "${eventData.nameTh}" ไม่สำเร็จ`;
          this.showDialogToast("warning", errorMsg);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    handleModalHidden() {
      this.resetForm();
      this.viewMode = "list";
    },
    async refreshList() {
      await this.fetchLabCompanyList({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
      });
    },
  },
};
</script>

<style>
</style>
